import { useState } from "react";

export interface RadioListProps {
  readonly items: string[];
  readonly selectedItem: string;
  readonly disabled?: boolean;
  readonly horizontal?: boolean;

  readonly onSelect: (name: string) => void;
}

/** widget that shows a list of radio buttons & allows you to pick one */
export function RadioList(props: RadioListProps) {
  const [unique] = useState(Math.round(Math.random() * 0xffffff));
  return (
    <span style={{ textAlign: 'left' }}>
      {props.items.map(item => {
        const id = `${unique}-${item}`;
        const content = <>
          <input type="radio" id={id} value={item} disabled={props.disabled}
            onChange={e => props.onSelect(e.target.value)}
            checked={item === props.selectedItem} />
          <label htmlFor={id}>{item}</label>
        </>;

        return (props.horizontal
          ? <span key={item}>{content}</span>
          : <div key={item}>{content}</div>
        );
      })}
    </span>
  );
}
